import { render, staticRenderFns } from "./QuestionSaved.vue?vue&type=template&id=59c290be&scoped=true&"
import script from "./QuestionSaved.vue?vue&type=script&lang=js&"
export * from "./QuestionSaved.vue?vue&type=script&lang=js&"
import style0 from "./QuestionSaved.vue?vue&type=style&index=0&id=59c290be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c290be",
  null
  
)

export default component.exports